export default __webpack_public_path__ + "media/images/features/ana/step_image2-39f08dd2c91f7417574677da1ea01037.png";